<app-dialog-header
	[title]="auction.auctionName"
	variant="info"
	(closeClick)="close()"
></app-dialog-header>
<div>
	<mat-dialog-content>
		<div class="row">
			<div class="field col-sm-6">
				<label>
					<b>{{ "auction.startDate" | translate }}</b>
				</label>
				<br />
				<div class="col-xs-12 col-12 col-md-6 form-group ps-0">
					<input
						style="margin-bottom: 6px"
						required="true"
						disabled="true"
						type="text"
						placeholder="DD/MM/YYYY"
						class="form-control"
						name="startDate"
						bsDatepicker
						[(ngModel)]="auction.startDate"
						#dpStart="bsDatepicker"
						placement="right"
						[bsConfig]="bsConfig"
					/>
					<timepicker
						id="hourFrom"
						name="startTime"
						[disabled]="true"
						required="true"
						[showSpinners]="false"
						[hourStep]="1"
						[minuteStep]="1"
						[showMeridian]="false"
						[(ngModel)]="auction.startTime"
					>
					</timepicker>
				</div>
			</div>
			<div class="field col-sm-6">
				<label>
					<b>{{ "auction.endDate" | translate }}</b>
				</label>
				<br />
				<div class="col-xs-12 col-12 col-md-6 form-group ps-0">
					<input
						style="margin-bottom: 6px"
						type="text"
						placeholder="DD/MM/YYYY"
						class="form-control"
						name="endDate"
						required="true"
						placement="right"
						bsDatepicker
						[(ngModel)]="auction.endDate"
						#dpEnd="bsDatepicker"
						[minDate]="auction.startDate"
						[bsConfig]="bsConfig"
					/>
					<timepicker
						id="hourTo"
						required
						name="endTime"
						[(ngModel)]="auction.endTime"
						[showSpinners]="false"
						[hourStep]="1"
						[minuteStep]="1"
						[showMeridian]="false"
					>
					</timepicker>
				</div>
			</div>
		</div>
		<br />
		<div class="row">
			<div class="field col-sm-12 text-center m-sm-0">
				<a
					(click)="extend()"
					class="btn btn-blue text-uppercase"
				>
					<i
						class="fa fa-expand-arrows-alt"
						style="padding-right: 8px"
					></i>
					{{ "dialog.extendTime.change" | translate }}
				</a>
			</div>
		</div>
	</mat-dialog-content>
</div>
